module.exports = __webpack_public_path__ + "static/img/czheader.a2d614b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/czheader.png
// module id = 14
// module chunks = 0